import React, { FC } from 'react';
import { Container, Grid, Theme, useMediaQuery } from '@material-ui/core';
import {
  associationLogo1,
  associationLogo2,
  associationLogo3,
  associationLogo4,
  associationLogo5,
  associationLogo6,
  associationLogo7,
  associationLogo8,
  associationLogo10,
  associationLogo11,
  associationLogo12,
  ourPartnersAlaska,
  ourPartnersAlaskaTelecom,
} from 'images/about-us';
import Image from 'blog/components/Image';
import Link from 'next/link';

const AssociationsLogosSection: FC = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  const data: Array<{ image: string; width: number; height: number; link?: string }> = [
    {
      image: associationLogo1,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo2,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo3,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo4,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo5,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo6,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo7,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo8,
      width: 208,
      height: 130,
    },
    /*{
      image: associationLogo9,
      width: 208,
      height: 130,
    },*/
    {
      image: associationLogo10,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo11,
      width: 208,
      height: 130,
    },
    {
      image: associationLogo12,
      width: 208,
      height: 130,
    },
    {
      image: ourPartnersAlaska,
      width: 140,
      height: 58,
    },
    {
      image: ourPartnersAlaskaTelecom,
      width: 140,
      height: 58,
    },
  ];
  return (
    <Container fixed>
      <Grid container direction="row" justifyContent="center" spacing={6}>
        {data.map((card, index) => (
          <Grid
            xs={12}
            sm={'auto'}
            item
            key={index}
            style={isSmall ? { margin: 'auto 0' } : { display: 'flex', justifyContent: 'center' }}
          >
            {card?.link ? (
              <div style={{ cursor: 'pointer' }}>
                <Link href={card.link}>
                  <Image src={card.image} alt={card.image} width={card.width} height={card.height} />
                </Link>
              </div>
            ) : (
              <Image src={card.image} alt={card.image} width={card.width} height={card.height} />
            )}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AssociationsLogosSection;
